import { Pipe, PipeTransform } from '@angular/core';
import { DropdownItem } from '@shared/ui/dropdown/interfaces/dropdown-item';
import { isDropdownHelpTextItem } from '@shared/ui/dropdown/helpers/dropdown-type-guards';

@Pipe({
  name: 'isDropdownHelpTextItem',
  standalone: false
})
export class IsDropdownHelpTextItemPipe implements PipeTransform {
  transform(item: DropdownItem): boolean {
    return isDropdownHelpTextItem(item);
  }
}
